var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "50%", center: "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "p1" }, [
            _vm._v("操作人： 此处带入操作人姓名 电话 公司信息"),
          ]),
          _c("p", { staticClass: "p2" }, [
            _c("span", [_vm._v("*")]),
            _vm._v(" 关闭理由："),
          ]),
          _c("div", { staticClass: "main" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    autosize: { minRows: 4, maxRows: 6 },
                    placeholder: "请输入内容",
                  },
                  model: {
                    value: _vm.textarea2,
                    callback: function ($$v) {
                      _vm.textarea2 = $$v
                    },
                    expression: "textarea2",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "right" }, [
              _c("p", { staticClass: "p3" }, [_vm._v("快捷输入：")]),
              _c("p", { staticStyle: { "margin-right": "0.06rem" } }, [
                _vm._v("平台无库存"),
              ]),
              _c("p", [_vm._v("恶意订单")]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "p4" },
            [
              _c("P", [_vm._v("订单号：")]),
              _c("P", [_vm._v("子订单号：")]),
              _c("P", [_vm._v("订单金额：￥123456")]),
              _c("p", { staticStyle: { "margin-bottom": "0.24rem" } }, [
                _vm._v("付款状态：已付款"),
              ]),
              _c("p", [
                _vm._v(
                  " 一旦关闭订单， 订单金额将自动生成退款订单并退回到客户的原支付渠道。 "
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }